import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import AudioWorkWaveformFunction from "./children/audioWorkWaveformFunction/AudioWorkWaveformFunction";
import AudioWorkSpeedFunction from "./children/audioWorkSpeedFunction/AudioWorkSpeedFunction";
import AudioWorkVolumeFunction from "./children/audioWorkVolumeFunction/AudioWorkVolumeFunction";
import AudioWorkCutFunction from "./children/audioWorkCutFunction/AudioWorkCutFunction";
import "@/assets/audioCutSpeedVolume.less";
import sentGAEvent from "@/ga";
import Utils from "@/utils";
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";

class AudioWorkContentFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      isAudioCurrentTimeChange: false,
    };
  }

  handlePauseAudio = () => {
    this.setState({ playing: false });
    if (this.props.audioCutSpeedVolumeObj.wavesurfer && this.props.audioCutSpeedVolumeObj.wavesurfer.isPlaying()) {
      this.props.audioCutSpeedVolumeObj.wavesurfer.pause();
    }
  };

  handlePlayAudio = () => {
    console.log(this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime());
    this.setState({ playing: true });
    if (this.props.audioCutSpeedVolumeObj.cutOrTrim === "cut") {
      if (
        this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime() >= Utils.getSeconds(this.props.audioCutSpeedVolumeObj.start) &&
        this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime() <= Utils.getSeconds(this.props.audioCutSpeedVolumeObj.end)
      ) {
        this.props.audioCutSpeedVolumeObj.wavesurfer.play(
          this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime(),
          Utils.getSeconds(this.props.audioCutSpeedVolumeObj.end)
        );
      } else {
        this.props.audioCutSpeedVolumeObj.wavesurfer.play(
          Utils.getSeconds(this.props.audioCutSpeedVolumeObj.start),
          Utils.getSeconds(this.props.audioCutSpeedVolumeObj.end)
        );
      }
    } else {
      if (
        this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime() <= Utils.getSeconds(this.props.audioCutSpeedVolumeObj.start) ||
        this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime() >= Utils.getSeconds(this.props.audioCutSpeedVolumeObj.end)
      ) {
        this.props.audioCutSpeedVolumeObj.wavesurfer.play(
          this.props.audioCutSpeedVolumeObj.wavesurfer.getCurrentTime(),
          this.props.audioCutSpeedVolumeObj.wavesurfer.getDuration()
        );
      } else {
        this.props.audioCutSpeedVolumeObj.wavesurfer.play(0, this.props.audioCutSpeedVolumeObj.wavesurfer.getDuration());
      }
    }
  };

  tooglePlay = () => {
    if (this.state.playing) {
      this.handlePauseAudio();
    } else {
      console.log("哈哈哈哈哈哈");
      let category = "";
      let action = "";
      switch (this.props.pageWork) {
        case "audioCut":
          category = "audio_cut_action";
          action = "audio_cut_play_click";
          break;
        case "audioCut":
          category = "audio_cut_action";
          action = "audio_cut_play_click";
          break;
        case "audioCut":
          category = "audio_cut_action";
          action = "audio_cut_play_click";
          break;
        default:
          break;
      }
      sentGAEvent({
        category,
        action,
      });
      this.handlePlayAudio();
    }
  };

  handlePlayFinishCallBack = () => {
    this.setState({ playing: false });
    if (this.props.audioCutSpeedVolumeObj.wavesurfer.isPlaying()) {
      this.props.audioCutSpeedVolumeObj.wavesurfer.pause();
    }
    if (this.props.audioCutSpeedVolumeObj.cutOrTrim === "cut") {
      this.props.audioCutSpeedVolumeObj.wavesurfer.setCurrentTime(Utils.getSeconds(this.props.audioCutSpeedVolumeObj.start));
      this.setState({ isAudioCurrentTimeChange: !this.state.isAudioCurrentTimeChange });
    } else {
      this.props.audioCutSpeedVolumeObj.wavesurfer.setCurrentTime(0);
      this.setState({ isAudioCurrentTimeChange: !this.state.isAudioCurrentTimeChange });
    }
  };

  render() {
    const { t, audioCutSpeedVolumeObj, isSmallerThanLimit } = this.props;
    return (
      <div className="workplace-content">
        <div className="content-hd">
          <div className="lft">
            <span className="audio-name">{Utils.omissionString(audioCutSpeedVolumeObj.name, 5, 7)}</span>
            <div className="audio-info">
              <span>
                {t("Size")}: {(audioCutSpeedVolumeObj.size / 1024 / 1024).toFixed(2)}MB
              </span>
              <span>
                {t("Duration")}: {audioCutSpeedVolumeObj.duration}
              </span>
            </div>
          </div>
          <div className="rgt" onClick={this.props.handleDeleteAudioObj}>
            <CloseIcon />
          </div>
        </div>
        <AudioWorkWaveformFunction
          pageWork={this.props.pageWork}
          isAudioCurrentTimeChange={this.state.isAudioCurrentTimeChange}
          audioCutSpeedVolumeObj={audioCutSpeedVolumeObj}
          onAudioCutSpeedVolumeObjChange={this.props.onAudioCutSpeedVolumeObjChange}
          handlePauseAudio={this.handlePauseAudio}
          handlePlayFinishCallBack={this.handlePlayFinishCallBack}
          handleTimeChangeType={this.props.handleTimeChangeType}
        />
        {isSmallerThanLimit ? (
          <p style={{ color: "#FF5C00", fontSize: 14, textAlign: "center", marginBottom: 12 }}>
            {t("common:The minimum time length is xxxs!", { num: 0.1 })}
          </p>
        ) : null}
        {this.props.pageWork === "audioCut" ? (
          <AudioWorkCutFunction
            isAudioCurrentTimeChange={this.state.isAudioCurrentTimeChange}
            audioCutSpeedVolumeObj={audioCutSpeedVolumeObj}
            playing={this.state.playing}
            handleIsAudioCurrentTimeChange={isAudioCurrentTimeChange => this.setState({ isAudioCurrentTimeChange })}
            onAudioCutSpeedVolumeObjChange={this.props.onAudioCutSpeedVolumeObjChange}
            tooglePlay={this.tooglePlay}
            handlePauseAudio={this.handlePauseAudio}
            handleTimeChangeType={this.props.handleTimeChangeType}
          />
        ) : this.props.pageWork === "audioSpeed" ? (
          <AudioWorkSpeedFunction
            audioCutSpeedVolumeObj={audioCutSpeedVolumeObj}
            playing={this.state.playing}
            onAudioCutSpeedVolumeObjChange={this.props.onAudioCutSpeedVolumeObjChange}
            tooglePlay={this.tooglePlay}
            handlePauseAudio={this.handlePauseAudio}
          />
        ) : (
          <AudioWorkVolumeFunction
            audioCutSpeedVolumeObj={audioCutSpeedVolumeObj}
            playing={this.state.playing}
            onAudioCutSpeedVolumeObjChange={this.props.onAudioCutSpeedVolumeObjChange}
            tooglePlay={this.tooglePlay}
            handlePauseAudio={this.handlePauseAudio}
          />
        )}
      </div>
    );
  }
}

export default withTranslation(["audioCutAndSpeedAndVolume", "common"])(AudioWorkContentFunction);
